import styled from 'styled-components';
import { Box } from '@mui/material';

const WizardStage = styled(Box)<{
  $index: number;
  $selectedIndex: number;
}>`
  display: ${({ $index, $selectedIndex }) =>
    $index === $selectedIndex ? 'block' : 'none'};
  width: 100%;
`;

export default WizardStage;
